import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EventItem,
  Lookups,
  Race,
  RaceSettings,
  RaceStartDateType,
  StartRaces
} from "@model";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import {RacesToStartCancelEditModalComponent} from "@components";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: 'app-event-measurements-management-race-list',
  templateUrl: './event-measurements-management-race-list.component.html',
  styleUrl: './event-measurements-management-race-list.component.scss'
})
export class EventMeasurementsManagementRaceListComponent {
  @Input({ required: true }) languages: Lookups[] = [];
  @Input({ required: true }) eventItem?: EventItem;
  @Input() raceSettingsList: RaceSettings[] = [];
  @Output() getFileFromServer = new EventEmitter<string>();
  @Output() onSaveOrUpdateRaceStart = new EventEmitter<StartRaces>();
  @Output() onRefreshEventResults = new EventEmitter<void>();
  @Output() goToEventManagement = new EventEmitter<void>();

  constructor(private modalService: NgbModal, private translocoService: TranslocoService) {}

  onOpenModalToStartRaces() {
    this.openModal("measurements.start.races.title", RaceStartDateType.START);
  }

  onOpenModalToStopRaces() {
    this.openModal("measurements.stop.races.title", RaceStartDateType.STOP);
  }

  onOpenModalToEditRaces() {
    this.openModal("measurements.edit.races.title", RaceStartDateType.EDIT);
  }

  private openModal(titleKey: string, raceStartDateType:RaceStartDateType) {
    const modalRef: NgbModalRef = this.modalService.open(RacesToStartCancelEditModalComponent, {
      centered: true,
      windowClass: 'races-to-start-cancel-modal'
    });
    modalRef.componentInstance.title = this.translocoService.translate(titleKey);
    modalRef.componentInstance.listOfRaces = this.eventItem?.racesList?.map(race => this.copyRaceData(race)) ?? [];
    modalRef.componentInstance.languages = this.languages;
    modalRef.componentInstance.eventItem = this.eventItem;
    modalRef.componentInstance.raceStartDateType = raceStartDateType;

    modalRef.result.then((startRaces: StartRaces) => {
      this.onSaveOrUpdateRaceStart.emit(startRaces);
    }, () => {});
  }

  private copyRaceData(race: Race) {
    return {
      id: race.id,
      raceStartItems: race.raceStartItems?.map(item => ({ ...item })) ?? [],
      name: race.name,
      nameEng: race.nameEng,
      nameIta: race.nameIta,
      nameSlo: race.nameSlo,
      startEvery: race.startEvery
    };
  }

  onGetFileFromServer(type: string) {
    this.getFileFromServer.next(type);
  }

  isVisibleStartRaces() {
    const items = this.eventItem?.racesList?.flatMap(race => race.raceStartItems ?? []) ?? [];
    return items.filter(item => item.started).length !== items.length;
  }

  isVisibleStopRaces() {
    return this.eventItem?.racesList?.some(race => this.findRaceStarted(race)) ?? false;
  }

  onRefreshResults() {
   this.onRefreshEventResults.emit();
  }

  onGoToEventManagement() {
    this.goToEventManagement.emit();
  }

  findRaceStarted(race: Race) {
    const startedItems = race.raceStartItems?.filter(item => item.started) ?? [];
    return startedItems.length ? startedItems.reduce((prev, curr) => curr.started! < prev.started! ? curr : prev).started : undefined;
  }
}
